import { TrainingsEntitiesContentBlockStatusEnum } from 'generated/resources/graphql'
import { makeObservable, observable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'

import i18n from 'modules/core/lib/i18n'

export type BlockConfig = {
  id?: number
  title?: string
  uuid?: string
  accesible?: boolean
  status?: TrainingsEntitiesContentBlockStatusEnum
}

export abstract class Block {
  id: number
  title: string
  uuid: string
  accesible: boolean
  status: TrainingsEntitiesContentBlockStatusEnum

  constructor(config: BlockConfig) {
    this.id = config.id || 0
    this.title = config.title || ''
    this.uuid = config.uuid || uuidv4()
    this.accesible = config.accesible || false
    this.status = config.status ?? 'notstarted'

    makeObservable(this, {
      title: observable,
      accesible: observable,
    })
  }

  abstract clone(): Block

  validate(): Record<string, string> {
    const errors: Record<string, string> = {}
    if (!this.title.trim()) {
      errors.title = i18n.t('trainings.content.validation.title_required')
    }
    return errors
  }
}
